import React, { useState, useEffect } from 'react';
import axios from '../../axiosConfig';
import '../../styles/ReportTemplatePreviewModal.css';

const ReportTemplatePreviewModal = ({ isOpen, onClose, template, onDelete }) => {
    const [assignedDogs, setAssignedDogs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    // Reset and fetch data when modal opens
    useEffect(() => {
        if (isOpen && template) {
            fetchAssignedDogs();
        }
        if (!isOpen) {
            setAssignedDogs([]);
            setError('');
        }
    }, [isOpen, template]);

    // Fetch dogs assigned to this template
    const fetchAssignedDogs = async () => {
        try {
            setLoading(true);
            setError('');
            const token = localStorage.getItem('jwt');

            // Fetch assignments for this report template
            const response = await axios.get(`/api/v1/reports/assignments/report/${template.id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });

            setAssignedDogs(response.data || []);
        } catch (err) {
            console.error('Error fetching assigned dogs:', err);
            // Don't show error for 404 - just means no assignments
            if (err.response?.status !== 404) {
                setError('Nie udało się pobrać przypisanych pupili');
            }
            setAssignedDogs([]);
        } finally {
            setLoading(false);
        }
    };

    // Handle click outside modal to close
    const handleOverlayClick = (e) => {
        if (e.target.classList.contains('rtpm-overlay')) {
            onClose();
        }
    };

    // Handle delete button
    const handleDelete = () => {
        if (onDelete) {
            onDelete(template);
        }
    };

    if (!isOpen || !template) return null;

    // Sort questions by order index
    const sortedQuestions = template.questions
        ? [...template.questions].sort((a, b) => a.orderIndex - b.orderIndex)
        : [];

    return (
        <div className="rtpm-overlay" onClick={handleOverlayClick}>
            <div className="rtpm-modal">
                <div className="rtpm-header">
                    <h2 className="rtpm-title">{template.title}</h2>
                    <p className="rtpm-count">Pytania ({sortedQuestions.length})</p>
                </div>

                <div className="rtpm-content">
                    {/* Questions Section */}
                    <div className="rtpm-questions-section">
                        {sortedQuestions.length === 0 ? (
                            <p className="rtpm-empty">Brak pytań w tym szablonie</p>
                        ) : (
                            <div className="rtpm-questions-list">
                                {sortedQuestions.map((question, index) => (
                                    <div key={question.id || index} className="rtpm-question-item">
                                        <span className="rtpm-question-number">{index + 1}.</span>
                                        <span className="rtpm-question-text">{question.questionText}</span>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>

                    {/* Assigned Dogs Section */}
                    <div className="rtpm-assigned-section">
                        <h3 className="rtpm-section-title">Przypisana dla:</h3>

                        {loading ? (
                            <p className="rtpm-loading">Ładowanie...</p>
                        ) : error ? (
                            <p className="rtpm-error">{error}</p>
                        ) : assignedDogs.length === 0 ? (
                            <p className="rtpm-empty">Nie przypisano do żadnego pupila</p>
                        ) : (
                            <div className="rtpm-dogs-list">
                                {assignedDogs.map((assignment) => (
                                    <div key={assignment.id} className="rtpm-dog-item">
                                        <div className="rtpm-dog-row">
                                            <span className="rtpm-dog-label">Imię psa</span>
                                            <span className="rtpm-dog-value">{assignment.dogName}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                </div>

                <div className="rtpm-footer">
                    <button
                        className="rtpm-delete-btn"
                        onClick={handleDelete}
                    >
                        Usuń raport
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ReportTemplatePreviewModal;